export default "__VITE_ASSET__ZQi5bvW$__"